'use strict';

var _defineProperty = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectDestructuringEmpty = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectDestructuringEmpty");

var _notifications;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationGroup = undefined;
exports.getNotification = getNotification;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _userTypes = require('../constants/userTypes');

var _userTypes2 = _interopRequireDefault(_userTypes);

var _IsUser = require('../utils/user/IsUser');

var _IsUser2 = _interopRequireDefault(_IsUser);

var _utils = require('../utils');

var _stringFormatters = require('../utils/stringFormatters');

var _notificationTypes = require('../constants/notificationTypes');

var _notificationTypes2 = _interopRequireDefault(_notificationTypes);

var _project = require('./project');

var _project2 = _interopRequireDefault(_project);

var _urlLocations = require('../routes/urlLocations');

var _buttons = require('../styled/buttons');

var _buttons2 = _interopRequireDefault(_buttons);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BtnLikeLink = _buttons2.default.BtnLikeLink;
/* eslint-disable react/display-name, react/prop-types */

var projectStatus = _project2.default.STATUS;
var paymentProvider = 'Mangopay';
var projectDetailsUrl = "".concat(_urlLocations.projectDetails, "/");
var projectEditUrl = "".concat(_urlLocations.projectEdit, "/");
var projectDataRoomAccessUrl = "".concat(_urlLocations.projectDataRoomAccess, "/");
var notificationGroup = exports.notificationGroup = {
  USER: 'USER',
  PROJECT: 'PROJECT'
};
var projectionTypes = {
  USER: 'kycDataUser',
  COMPANY: 'companyRegistration',
  INDIVIDUAL: 'individualRegistration'
};

var defaultNotification = function defaultNotification(type) {
  return {
    group: notificationGroup.USER,
    pushTitle: function pushTitle() {
      return "NEW NOTIFICATION TYPE -> ".concat(type);
    },
    title: function title() {
      return "NEW NOTIFICATION TYPE -> ".concat(type);
    },
    content: function content() {
      return 'NEW NOTIFICATION DESCRIPTION ->';
    }
  };
};

var expireInDaysMessage = function expireInDaysMessage(expireInDays) {
  return expireInDays !== 1 ? 'soon' : 'tomorrow';
};

var notifications = (_notifications = {}, _defineProperty(_notifications, _notificationTypes2.default.PROJECT_LIKED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref) {
    var projectTitle = _ref.projectTitle;
    return "Your project \"".concat(projectTitle, "\" was liked by an investor");
  },
  title: function title(_ref2) {
    var projectTitle = _ref2.projectTitle;
    return "Your project \"".concat(projectTitle, "\" was liked by an investor");
  },
  content: function content(_ref3) {
    var userName = _ref3.userName,
        projectTitle = _ref3.projectTitle,
        projectId = _ref3.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "Investor ".concat(userName, " liked your project \"").concat(projectTitle, "\". You can view project details "), _react2.default.createElement(_reactRouterDom.Link, {
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_UNLIKED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref4) {
    var projectTitle = _ref4.projectTitle;
    return "Your project \"".concat(projectTitle, "\" was unliked by an investor");
  },
  title: function title(_ref5) {
    var projectTitle = _ref5.projectTitle;
    return "Your project \"".concat(projectTitle, "\" was unliked by an investor");
  },
  content: function content(_ref6) {
    var userName = _ref6.userName,
        projectTitle = _ref6.projectTitle,
        projectId = _ref6.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "Investor ".concat(userName, " unliked your project \"").concat(projectTitle, "\". You can view project details "), _react2.default.createElement(_reactRouterDom.Link, {
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.KYC_NOT_PASSED, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref7) {
    var userType = _ref7.userType;
    return "New ".concat((0, _utils.capitalizeText)(userType, '_'), " hasn't passed compliance check.");
  },
  title: function title(_ref8) {
    var userType = _ref8.userType;
    return "New ".concat((0, _utils.capitalizeText)(userType, '_'), " hasn't passed compliance check");
  },
  content: function content(_ref9) {
    var type = _ref9.type,
        userName = _ref9.userName,
        userId = _ref9.userId;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(userName, " user hasn't passed compliance check. View KYC results "), _react2.default.createElement(_reactRouterDom.Link, {
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      to: {
        pathname: "".concat(_urlLocations.KYCUserStatus, "/").concat(userId, "?projectionName=").concat(projectionTypes[type]),
        state: {
          projection: type
        }
      }
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SP_SUBSCRIPTION_ACTIVATED, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return 'Your subscription has been activated';
  },
  title: function title() {
    return 'Your subscription has been activated';
  },
  content: function content(_ref10) {
    var expiredAt = _ref10.expiredAt,
        startDate = _ref10.startDate;
    return _react2.default.createElement(_react2.default.Fragment, null, "Finbursa has activated your subscription. Start date: ".concat((0, _utils.formatDate)(startDate, 'DD MMM YYYY HH:mm'), ", expiration date: ").concat((0, _utils.formatDate)(expiredAt, 'DD MMM YYYY HH:mm'), "."), _react2.default.createElement('br', null), 'You can now continue working on your platform and take full advantage of the tools and features available.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.USER_DATA_CHANGED, [{
  users: [_userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER],
  pushTitle: function pushTitle() {
    return 'User profile is updated';
  },
  group: notificationGroup.USER,
  title: function title() {
    return 'Your account information was updated';
  },
  content: function content() {
    return _react2.default.createElement(_react2.default.Fragment, null, "Your account information was updated by the admin team. Check your profile for details.");
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PASSED_KYC, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return 'User passed KYC.';
  },
  title: function title() {
    return 'Compliance Checks Passed';
  },
  content: function content(_, _ref11) {
    var localUserType = _ref11.localUserType;
    var isUser = new _IsUser2.default(localUserType);
    var userHandling = isUser.adminSP ? 'We’re pleased to inform you that you have successfully passed the compliance checks. Please check your email for detailed information regarding the subscription payment process' : 'Congratulations! You have successfully passed the initial KYC screening.You can now proceed and fully enjoy all the features and benefits of the FinBursa Platform.';
    return _react2.default.createElement(_react2.default.Fragment, null, userHandling);
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.MANGOPAY_ACCOUNT_CREATED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "".concat(paymentProvider, " Notification: Your payment account is created.");
  },
  title: function title() {
    return "".concat(paymentProvider, " Notification: Your payment account is created");
  },
  content: function content() {
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(paymentProvider, " Notification: We successfully created payment account for you.\n            You can start work with payments on platform."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SP_USERS_CREATION_SUCCESSFUL, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref12) {
    var userType = _ref12.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " creation successfully completed.");
  },
  title: function title(_ref13) {
    var userType = _ref13.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " creation successfully completed.");
  },
  content: function content(_ref14) {
    var userType = _ref14.userType,
        createdUsersCounter = _ref14.createdUsersCounter,
        creationDate = _ref14.creationDate;
    var isUser = new _IsUser2.default(userType);
    var userHandlingUrl = isUser.issuerSP ? _urlLocations.SPIssuersList : isUser.investorSP ? _urlLocations.SPInvestorsList : null;
    return _react2.default.createElement(_react2.default.Fragment, null, "All ".concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), " from file, which\n              you uploaded on ").concat((0, _utils.formatDate)(creationDate, 'DD MMM YYYY HH:mm'), ", were created. \n              Total amount of created users is  ").concat(createdUsersCounter, ", you can see them in the "), userHandlingUrl && _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: userHandlingUrl
    }, 'list'), " of ".concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), "."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SP_DOCUMENT_UPLOAD_REQUEST, [{
  users: [_userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref15) {
    var userType = _ref15.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " document approval request.");
  },
  title: function title(_ref16) {
    var userType = _ref16.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " document approval request.");
  },
  content: function content(_ref17) {
    var userType = _ref17.userType,
        creationDate = _ref17.creationDate;
    var isUser = new _IsUser2.default(userType);
    var userHandlingUrl = isUser.issuerSP ? _urlLocations.SPIssuersList : isUser.investorSP ? _urlLocations.SPInvestorsList : null;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), " file, which\n              was uploaded on ").concat((0, _utils.formatDate)(creationDate, 'DD MMM YYYY HH:mm'), ", needs approval. You can see them in the "), userHandlingUrl && _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: userHandlingUrl
    }, 'list'), " of ".concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), "."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SP_DOCUMENT_UPLOAD_SUCCESSFUL, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref18) {
    var userType = _ref18.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " document uploaded successfully.");
  },
  title: function title(_ref19) {
    var userType = _ref19.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " document uploaded successfully.");
  },
  content: function content(_ref20) {
    var userType = _ref20.userType,
        creationDate = _ref20.creationDate;
    var isUser = new _IsUser2.default(userType);
    var userHandlingUrl = isUser.issuerSP ? _urlLocations.SPIssuersList : isUser.investorSP ? _urlLocations.SPInvestorsList : null;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), " file, which\n              was uploaded on ").concat((0, _utils.formatDate)(creationDate, 'DD MMM YYYY HH:mm'), ", was sent for approval. You can see them in the "), userHandlingUrl && _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: userHandlingUrl
    }, 'list'), " of ".concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), "."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SP_DOCUMENT_UPLOAD_REJECTED, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref21) {
    var userType = _ref21.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " document rejected.");
  },
  title: function title(_ref22) {
    var userType = _ref22.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " document rejected.");
  },
  content: function content(_ref23) {
    var userType = _ref23.userType,
        creationDate = _ref23.creationDate,
        rejectionReason = _ref23.rejectionReason;
    var isUser = new _IsUser2.default(userType);
    var userHandlingUrl = isUser.issuerSP ? _urlLocations.SPIssuersList : isUser.investorSP ? _urlLocations.SPInvestorsList : null;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), " file, which\n              was uploaded on ").concat((0, _utils.formatDate)(creationDate, 'DD MMM YYYY HH:mm'), ", was rejected for the following reasons: ").concat(rejectionReason, ". You can see them in the "), userHandlingUrl && _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: userHandlingUrl
    }, 'list'), " of ".concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), "."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SP_USERS_CREATION_FAILED, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref24) {
    var userType = _ref24.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " creation completed.");
  },
  title: function title(_ref25) {
    var userType = _ref25.userType;
    return "".concat((0, _utils.capitalizeText)(userType, '_'), " creation completed.");
  },
  content: function content(_ref26) {
    var createdUsersCounter = _ref26.createdUsersCounter,
        userType = _ref26.userType,
        creationDate = _ref26.creationDate,
        notCreatedUsersCounter = _ref26.notCreatedUsersCounter,
        link = _ref26.link;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(createdUsersCounter, " \n              ").concat((0, _utils.replaceFirstSpace)((0, _stringFormatters.stringTypeNormalizer)(userType)), " from file, which you\n                uploaded on ").concat((0, _utils.formatDate)(creationDate, 'DD MMM YYYY HH:mm'), ", were\n                successfully created. Amount of not created users is \n              ").concat(notCreatedUsersCounter, " , you can download file with errors description "), _react2.default.createElement('a', {
      className: 'notification-list__link',
      href: link,
      target: '_blank'
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.KYC_DOCUMENT_VALIDATED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return 'Your KYC document was accepted.';
  },
  title: function title() {
    return 'Your KYC document was accepted';
  },
  content: function content(_ref27) {
    var type = _ref27.type;
    return "Your submitted \"".concat((0, _utils.capitalizeText)(type, '_'), "\" was successfully approved.");
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.KYC_DOCUMENT_REFUSED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return 'Document(s) submitted for KYC were rejected.';
  },
  title: function title() {
    return 'Document(s) submitted for KYC were rejected';
  },
  content: function content(_ref28) {
    var type = _ref28.type,
        creationDate = _ref28.creationDate,
        refusedReasonType = _ref28.refusedReasonType,
        refusedReasonMessage = _ref28.refusedReasonMessage;
    return _react2.default.createElement(_react2.default.Fragment, null, "The following KYC document(s) were rejected during review:  \n            \"".concat((0, _utils.capitalizeText)(type, '_'), "\", uploaded on ").concat((0, _utils.formatDate)(creationDate, 'DD MMM YYYY HH:mm'), ". \n             Reason of rejection: ").concat((0, _stringFormatters.stringTypeNormalizerExceptFirstLetter)(refusedReasonType), ". "), refusedReasonMessage ? "(".concat(refusedReasonMessage, ")") : null);
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_NDA_SIGNED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref29) {
    var viewersUserType = _ref29.viewersUserType;
    return "New ".concat((0, _stringFormatters.stringTypeNormalizer)(viewersUserType, '_'), " signed NDA for your project");
  },
  title: function title(_ref30) {
    var viewersUserType = _ref30.viewersUserType;
    return "New ".concat((0, _stringFormatters.stringTypeNormalizer)(viewersUserType, '_'), " signed NDA for your project");
  },
  content: function content(_ref31) {
    var viewersUserType = _ref31.viewersUserType,
        userName = _ref31.userName,
        projectTitle = _ref31.projectTitle;
    return _react2.default.createElement(_react2.default.Fragment, null, "New ".concat((0, _stringFormatters.stringTypeNormalizer)(viewersUserType, '_'), " ").concat(userName, " signed NDA \n            for your project \"").concat(projectTitle, "\". Access to Dataroom was granted."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_NDA_SIGNED_TO_RM, [{
  users: [_userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref32) {
    _objectDestructuringEmpty(_ref32);

    return "NDA for DataRoom was signed";
  },
  title: function title(_ref33) {
    _objectDestructuringEmpty(_ref33);

    return "NDA for DataRoom was signed";
  },
  content: function content(_ref34) {
    var viewersUserType = _ref34.viewersUserType,
        userName = _ref34.userName,
        projectTitle = _ref34.projectTitle,
        projectId = _ref34.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(userName, " signed NDA \n            for Data Room of "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.DATA_ROOM_ACCESS_REQUESTED_TO_RM, [{
  users: [_userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref35) {
    _objectDestructuringEmpty(_ref35);

    return "Dataroom access was requested";
  },
  title: function title(_ref36) {
    _objectDestructuringEmpty(_ref36);

    return "Dataroom access was requested";
  },
  content: function content(_ref37) {
    var viewersUserType = _ref37.viewersUserType,
        userName = _ref37.userName,
        projectTitle = _ref37.projectTitle,
        projectId = _ref37.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(userName, " requested access to the Data Room of "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_NDA_SIGNED_NOT_APPROVED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle() {
    return 'NDA for Dataroom was signed';
  },
  title: function title() {
    return 'NDA for Dataroom was signed';
  },
  content: function content(_ref38) {
    var userName = _ref38.userName,
        projectTitle = _ref38.projectTitle,
        projectId = _ref38.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(userName, " signed NDA for Dataroom of "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), '.', ' You can grant access ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDataRoomAccessUrl).concat(projectId, "#nda-signed")
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_NDA_SIGNED_TO_EXTERNAL_POC, [{
  users: [_userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref39) {
    _objectDestructuringEmpty(_ref39);

    return "NDA for DataRoom was signed";
  },
  title: function title(_ref40) {
    _objectDestructuringEmpty(_ref40);

    return "NDA for DataRoom was signed";
  },
  content: function content(_ref41) {
    var userName = _ref41.userName,
        projectTitle = _ref41.projectTitle,
        projectId = _ref41.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(userName, " signed NDA for Dataroom of "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_NDA_REQUESTED_TO_EXTERNAL_POC, [{
  users: [_userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref42) {
    _objectDestructuringEmpty(_ref42);

    return "Dataroom access was requested";
  },
  title: function title(_ref43) {
    _objectDestructuringEmpty(_ref43);

    return "Dataroom access was requested";
  },
  content: function content(_ref44) {
    var userName = _ref44.userName,
        projectTitle = _ref44.projectTitle,
        projectId = _ref44.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(userName, " requested access to the Data Room of "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_PUBLISHED_FOR_REVIEW, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref45) {
    var projectTitle = _ref45.projectTitle,
        userName = _ref45.userName;
    return "\"".concat(projectTitle, "\" project is published by ").concat(userName || 'empty username');
  },
  title: function title(_ref46) {
    var projectTitle = _ref46.projectTitle;
    return "\"".concat(projectTitle, "\" is published");
  },
  content: function content(_ref47) {
    var userName = _ref47.userName,
        projectTitle = _ref47.projectTitle,
        publishedDate = _ref47.publishedDate,
        projectId = _ref47.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), ' project is published by ', userName || 'empty username', ' at', " ".concat((0, _utils.formatDate)(publishedDate, 'DD MMM YYYY HH:mm'), "."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_PUBLIC_MARKETPLACE_VISIBILITY, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle() {
    return "Update on your project visibility";
  },
  title: function title() {
    return "Update on your project visibility";
  },
  content: function content(_ref48) {
    var projectTitle = _ref48.projectTitle,
        projectId = _ref48.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), ' project is now visible on the public marketplace ');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_PUBLISHED, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR, _userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref49) {
    var projectTitle = _ref49.projectTitle,
        userName = _ref49.userName;
    return "\"".concat(projectTitle, "\" project is published by ").concat(userName || 'empty username');
  },
  title: function title(_ref50) {
    var projectTitle = _ref50.projectTitle;
    return "\"".concat(projectTitle, "\" is published");
  },
  content: function content(_ref51) {
    var userName = _ref51.userName,
        projectTitle = _ref51.projectTitle,
        publishedDate = _ref51.publishedDate,
        projectId = _ref51.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), ' project is published by ', userName || 'empty username', ' at', " ".concat((0, _utils.formatDate)(publishedDate, 'DD MMM YYYY HH:mm'), "."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.DATA_ROOM_ACCESS_REJECTED, [{
  users: [_userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref52) {
    var projectTitle = _ref52.projectTitle;
    return "Dataroom access to \"".concat(projectTitle, "\" was rejected");
  },
  title: function title(_ref53) {
    var projectTitle = _ref53.projectTitle;
    return "Dataroom access to \"".concat(projectTitle, "\" was rejected");
  },
  content: function content(_ref54) {
    var creationDate = _ref54.creationDate,
        projectTitle = _ref54.projectTitle,
        projectId = _ref54.projectId,
        message = _ref54.message;
    return _react2.default.createElement(_react2.default.Fragment, null, 'Project issuer rejected your access to Dataroom content.', _react2.default.createElement('br', null), "Rejection message: \"".concat(message, "\". You can see project details "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_REJECTED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref55) {
    var projectTitle = _ref55.projectTitle;
    return "\"".concat(projectTitle, "\" project is rejected");
  },
  title: function title(_ref56) {
    var projectTitle = _ref56.projectTitle;
    return "\"".concat(projectTitle, "\" project is rejected");
  },
  content: function content(_ref57, _ref58) {
    var userName = _ref57.userName,
        projectTitle = _ref57.projectTitle,
        projectId = _ref57.projectId;
    var localUserType = _ref58.localUserType,
        isProjectFinished = _ref58.isProjectFinished;
    var isUser = new _IsUser2.default(localUserType);
    var linkToProjectDetails = "".concat(projectDetailsUrl).concat(projectId);
    return _react2.default.createElement(_react2.default.Fragment, null, "\"".concat(projectTitle, "\" project is rejected by "), userName || 'empty username', '. Reason for rejection can be checked ', isUser.allIssuers ? _react2.default.createElement(BtnLikeLink, {
      className: 'notification-list__link',
      onClick: function onClick() {
        return isProjectFinished(projectId, true);
      }
    }, 'here') : _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: linkToProjectDetails
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_END_DATE_EDITED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref59) {
    var projectTitle = _ref59.projectTitle;
    return "End date changed for\"".concat(projectTitle, "\"");
  },
  title: function title(_ref60) {
    var projectTitle = _ref60.projectTitle;
    return "End date changed for\"".concat(projectTitle, "\"");
  },
  content: function content(_ref61) {
    var projectTitle = _ref61.projectTitle,
        endDate = _ref61.endDate;
    return _react2.default.createElement(_react2.default.Fragment, null, " The End Date for project \"".concat(projectTitle, "\" has been successfully changed to \"\n              ").concat((0, _utils.formatDate)(endDate, 'DD MMM YYYY HH:mm'), "\". Please contact us if you need further assistance."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_APPROVED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref62) {
    var projectTitle = _ref62.projectTitle;
    return "\"".concat(projectTitle, "\" project is approved");
  },
  title: function title(_ref63) {
    var projectTitle = _ref63.projectTitle;
    return "\"".concat(projectTitle, "\" project is approved");
  },
  content: function content(_ref64) {
    var userName = _ref64.userName,
        projectTitle = _ref64.projectTitle,
        projectId = _ref64.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), ' project is approved by the Admin', '. Your project is now visible for all users at the FinBursa platform.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.DEAL_MANAGEMENT_TEAM_MEMBER_ADDED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.OTHER_STRATEGIC_PARTNER, _userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref65) {
    var projectTitle = _ref65.projectTitle;
    return "\"".concat(projectTitle, "\" Deal Management Module Granted");
  },
  title: function title(_ref66) {
    var projectTitle = _ref66.projectTitle;
    return "\"".concat(projectTitle, "\" Deal Management Module Granted");
  },
  content: function content(_ref67) {
    var userName = _ref67.userName,
        projectTitle = _ref67.projectTitle,
        projectId = _ref67.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "You've been added as a team member to ".concat(projectTitle, " Deal Management Module."), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, "Click here"), ' to access the dashboard.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.DEAL_MANAGEMENT_DEAL_OWNER_ADDED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.OTHER_STRATEGIC_PARTNER, _userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref68) {
    var projectTitle = _ref68.projectTitle;
    return "\"".concat(projectTitle, "\" Deal Ownership Granted");
  },
  title: function title(_ref69) {
    var projectTitle = _ref69.projectTitle;
    return "\"".concat(projectTitle, "\" Deal Ownership Granted");
  },
  content: function content(_ref70) {
    var userName = _ref70.userName,
        projectTitle = _ref70.projectTitle,
        projectId = _ref70.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, "You've been assigned as the deal owner to ".concat(projectTitle, " Deal Management Module."), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, "Click here"), ' to access the dashboard.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.CO_SP_USER_KYC_CHECK_REQUEST, [{
  users: [_userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "New Sign up Approval";
  },
  title: function title() {
    return "New Sign up Approval";
  },
  content: function content(_ref71) {
    var spWorkerName = _ref71.spWorkerName,
        spUserName = _ref71.spUserName;
    return _react2.default.createElement(_react2.default.Fragment, null, spWorkerName || 'empty username ', ' ', 'requested approval for ', ' ', spUserName || 'empty username');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.REJECTED_KYC_TO_RM, [{
  users: [_userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "New Sign up was rejected";
  },
  title: function title() {
    return "New Sign up was rejected";
  },
  content: function content(_ref72) {
    var coName = _ref72.coName,
        rejectedUserName = _ref72.rejectedUserName,
        refusedReasonMessage = _ref72.refusedReasonMessage;
    return _react2.default.createElement(_react2.default.Fragment, null, coName || 'empty username ', ' ', 'rejected the sign up for ', ' ', rejectedUserName || 'empty username', '. ', 'Reason: ', ' ', refusedReasonMessage);
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_INVESTED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref73) {
    var userType = _ref73.userType,
        projectTitle = _ref73.projectTitle,
        userName = _ref73.userName,
        amount = _ref73.amount,
        currency = _ref73.currency;
    var isUser = new _IsUser2.default(userType);

    if (_IsUser2.default.superAdmin) {
      return "Your project \"".concat(projectTitle, "\" received investment from \n              ").concat(userName || 'empty username', ". Amount of investment: \n              ").concat(amount || 0, " ").concat(currency || 'USD');
    }

    return "Your project \"".concat(projectTitle, "\" received investment.");
  },
  title: function title(_ref74) {
    var projectTitle = _ref74.projectTitle;
    return "Your project \"".concat(projectTitle, "\" received investment");
  },
  content: function content(_ref75) {
    var projectTitle = _ref75.projectTitle,
        userName = _ref75.userName,
        amount = _ref75.amount,
        currency = _ref75.currency;
    var amountCurrency = "".concat(amount ? amount.toLocaleString() : 0, " ").concat(currency || 'USD');
    return _react2.default.createElement(_react2.default.Fragment, null, "Your project \"".concat(projectTitle, "\" received investment from "), userName || 'empty username', ". Amount of investment: ".concat(amountCurrency, "."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_FULLY_INVESTED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.SUPER_ADMIN, _userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref76) {
    var userType = _ref76.userType,
        projectTitle = _ref76.projectTitle;
    var isUser = new _IsUser2.default(userType);

    if (isUser.issuer) {
      return "Funding target for the raise is received for your project \"".concat(projectTitle, "\"");
    }

    return "Funding target for the raise is received for project \"".concat(projectTitle, "\"");
  },
  title: function title(_ref77) {
    var projectTitle = _ref77.projectTitle;
    return "Funding target for the raise is received for your project \"".concat(projectTitle, "\"");
  },
  content: function content(_ref78) {
    var targetAmountForTheRaise = _ref78.targetAmountForTheRaise,
        currency = _ref78.currency,
        projectTitle = _ref78.projectTitle;
    var targetAmountCurrencyRaise = "".concat(targetAmountForTheRaise || 0, " ").concat(currency || 'USD');
    return _react2.default.createElement(_react2.default.Fragment, null, "Funding target for the raise in sum ".concat(targetAmountCurrencyRaise, " is received for project \n            \"").concat(projectTitle, "\". Project is moved to finished. All investments are moved from project \n            account to project owner account."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_FINISHED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.SUPER_ADMIN, _userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  title: function title(_ref79) {
    var projectTitle = _ref79.projectTitle;
    return "".concat(projectTitle, " has been unpublished");
  },
  content: function content(_ref80) {
    var projectTitle = _ref80.projectTitle;
    return _react2.default.createElement(_react2.default.Fragment, null, "Your project ".concat(projectTitle, " has been unpublished because it has reached its end date. You can add more details on the project closure."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.REJECTED_KYC, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  title: function title() {
    return "Your FinBursa Application Has Been Rejected";
  },
  content: function content(_ref81) {
    var refusedReasonMessage = _ref81.refusedReasonMessage;
    return _react2.default.createElement(_react2.default.Fragment, null, "Unfortunately, your FinBursa application has been rejected for the following reason: ".concat(refusedReasonMessage));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_NOT_RECEIVED_TARGET_AMOUNT, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.SUPER_ADMIN, _userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref82) {
    var projectTitle = _ref82.projectTitle;
    return "Project \"".concat(projectTitle, "\" doesn't receive Funding target for the raise.");
  },
  title: function title(_ref83) {
    var projectTitle = _ref83.projectTitle;
    return "Your project \"".concat(projectTitle, "\" doesn't receive Funding target for the raise");
  },
  content: function content(_ref84) {
    var projectTitle = _ref84.projectTitle;
    return _react2.default.createElement(_react2.default.Fragment, null, "Project \"".concat(projectTitle, "\" doesn't receive Funding target for the raise. It is \n              moved to the finished projects, all invested money are returned to Investors' \n              accounts."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_NOT_RECEIVED_TARGET_AMOUNT_FOR_INVESTOR, [{
  users: [_userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref85) {
    var projectTitle = _ref85.projectTitle;
    return "Project \"".concat(projectTitle, "\" doesn't receive Funding target for the raise.");
  },
  title: function title(_ref86) {
    var projectTitle = _ref86.projectTitle;
    return "Project \"".concat(projectTitle, "\" doesn't receive Funding target for the raise");
  },
  content: function content(_ref87) {
    var projectTitle = _ref87.projectTitle,
        amount = _ref87.amount,
        currency = _ref87.currency;
    var amountCurrency = "".concat(amount ? amount.toLocaleString() : 0, " ").concat(currency || 'USD');
    return _react2.default.createElement(_react2.default.Fragment, null, "Project \"".concat(projectTitle, "\" doesn't receive Funding target for the raise. Your\n              investment ").concat(amountCurrency, " is returned to your account."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PAY_IN_TRANSACTION_SUCCESSFUL, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "".concat(paymentProvider, " Notification: E-wallet was credited successfully.");
  },
  title: function title() {
    return "".concat(paymentProvider, " Notification: E-wallet was credited successfully");
  },
  content: function content(_ref88) {
    var paymentAmount = _ref88.paymentAmount;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(paymentProvider, " Notification: Your E-wallet was successfully credited by ").concat(paymentAmount, " USD."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PAY_IN_TRANSACTION_FAILED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "".concat(paymentProvider, " Notification: Bank account transaction failed.");
  },
  title: function title() {
    return "".concat(paymentProvider, " Notification: Bank account transaction failed");
  },
  content: function content(_ref89) {
    var executionDate = _ref89.executionDate;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(paymentProvider, " Notification: Your transaction dated \n            ").concat((0, _utils.formatDate)(executionDate, 'DD MMM YYYY HH:mm'), " to credit your E-wallet failed. Please try again."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PAY_OUT_TRANSACTION_SUCCESSFUL, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "".concat(paymentProvider, " Notification: Bank account transaction was successful.");
  },
  title: function title() {
    return "".concat(paymentProvider, " Notification: Bank account transaction was successful");
  },
  content: function content(_ref90) {
    var paymentAmount = _ref90.paymentAmount;
    return "".concat(paymentProvider, " Notification: Your bank account was credited by ").concat(paymentAmount, " USD.");
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PAY_OUT_TRANSACTION_FAILED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "".concat(paymentProvider, " Notification: Bank account transaction failed.");
  },
  title: function title() {
    return "".concat(paymentProvider, " Notification: Bank account transaction failed");
  },
  content: function content(_ref91) {
    var executionDate = _ref91.executionDate;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(paymentProvider, " Notification: Your transaction dated ").concat((0, _utils.formatDate)(executionDate, 'DD MMM YYYY HH:mm'), " \n            to transfer money from your E-wallet failed. Please try again."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.DATA_ROOM_ACCESS_REQUESTED, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref92) {
    var projectTitle = _ref92.projectTitle;
    return "Dataroom access to your project \"".concat(projectTitle, "\" is requested.");
  },
  title: function title(_ref93) {
    var projectTitle = _ref93.projectTitle;
    return "Dataroom access to your project \"".concat(projectTitle, "\" is requested");
  },
  content: function content(_ref94) {
    var userName = _ref94.userName,
        projectTitle = _ref94.projectTitle,
        message = _ref94.message,
        projectId = _ref94.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, userName || 'empty username', ' requested access to Dataroom of ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), '.', _react2.default.createElement('br', null), "Message: \"".concat(message, "\". You can grant access "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: {
        pathname: "".concat(projectDataRoomAccessUrl).concat(projectId),
        hash: '#without-signed-nda'
      }
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.DATA_ROOM_ACCESS_GRANTED, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER, _userTypes2.default.INVESTOR, _userTypes2.default.ADVISOR],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref95) {
    var projectTitle = _ref95.projectTitle;
    return "Dataroom access to \"".concat(projectTitle, "\" was granted.");
  },
  title: function title(_ref96) {
    var projectTitle = _ref96.projectTitle;
    return "Dataroom access to \"".concat(projectTitle, "\" was granted");
  },
  content: function content(_ref97) {
    var projectId = _ref97.projectId,
        projectTitle = _ref97.projectTitle;
    return _react2.default.createElement(_react2.default.Fragment, null, 'Project issuer granted you access to ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), ' Dataroom content.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.FIRST_TIME_VIEW, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref98) {
    var viewersUserType = _ref98.viewersUserType;
    return "".concat((0, _utils.capitalizeText)(viewersUserType, '_'), " is viewing your project.");
  },
  title: function title(_ref99) {
    var viewersUserType = _ref99.viewersUserType;
    return "".concat((0, _utils.capitalizeText)(viewersUserType, '_'), " is viewing your project");
  },
  content: function content(_ref100) {
    var viewersUserType = _ref100.viewersUserType,
        userName = _ref100.userName,
        projectId = _ref100.projectId,
        projectTitle = _ref100.projectTitle;
    return _react2.default.createElement(_react2.default.Fragment, null, "An ".concat((0, _utils.capitalizeText)(viewersUserType, '_'), "  is viewing your project "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_INVESTED_FOR_ISSUER, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref101) {
    var projectTitle = _ref101.projectTitle;
    return "Your project \"".concat(projectTitle, "\" received investment.");
  },
  title: function title(_ref102) {
    var projectTitle = _ref102.projectTitle;
    return "Your project \"".concat(projectTitle, "\" received investment");
  },
  content: function content(_ref103) {
    var projectTitle = _ref103.projectTitle,
        advisorFullName = _ref103.advisorFullName,
        investorFullName = _ref103.investorFullName,
        amount = _ref103.amount,
        currency = _ref103.currency,
        projectId = _ref103.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, 'You project ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), ' received investment from Advisor ', "".concat(advisorFullName, " on behalf of ").concat(investorFullName, ". \n            Amount of investment: ").concat(amount, " ").concat(currency, "."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_INVESTED_BY_ADVISOR, [{
  users: [_userTypes2.default.INVESTOR, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref104) {
    var projectTitle = _ref104.projectTitle;
    return "Your private banker invested into project \"".concat(projectTitle, "\".");
  },
  title: function title(_ref105) {
    var projectTitle = _ref105.projectTitle;
    return "Your private banker invested into project \"".concat(projectTitle, "\"");
  },
  content: function content(_ref106, _ref107) {
    var userName = _ref106.userName,
        currency = _ref106.currency,
        amount = _ref106.amount,
        projectTitle = _ref106.projectTitle,
        projectId = _ref106.projectId;
    var selectCheckingProject = _ref107.selectCheckingProject;
    return _react2.default.createElement(_react2.default.Fragment, null, "Private banker ".concat(userName, " invested ").concat(amount, " ").concat(currency, " into "), _react2.default.createElement('a', {
      href: '#',
      className: 'notification-list__link',
      onClick: function onClick(e) {
        e.preventDefault();
        selectCheckingProject(projectId);
      }
    }, projectTitle), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.RISK_SCREEN_NO_ANSWER, [{
  users: [_userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "RiscScreen API doesn't return information.";
  },
  title: function title() {
    return "RiscScreen API doesn't return information";
  },
  content: function content(_ref108) {
    var userType = _ref108.userType,
        userId = _ref108.userId,
        type = _ref108.type,
        userName = _ref108.userName;
    return _react2.default.createElement(_react2.default.Fragment, null, "RiscScreen API doesn't answer to requested compliance check for ".concat((0, _stringFormatters.stringTypeNormalizer)(userType, '_'), " "), "".concat(userName, ". Check user details "), _react2.default.createElement(_reactRouterDom.Link, {
      to: {
        pathname: "".concat(_urlLocations.KYCUserStatus, "/").concat(userId, "?projectionName=").concat(projectionTypes[type]),
        state: {
          projection: type
        }
      }
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SP_ADMIN_APPLIED, [{
  users: [_userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref109) {
    var subDomain = _ref109.subDomain;
    return "\"".concat(subDomain, "\" strategic partner applied for registration.");
  },
  title: function title() {
    return 'New strategic partner applied for registration';
  },
  content: function content(_ref110) {
    var email = _ref110.email,
        country = _ref110.country,
        subDomain = _ref110.subDomain;
    return _react2.default.createElement(_react2.default.Fragment, null, '"', subDomain, '" strategic partner applied for registration.', _react2.default.createElement('div', {
      className: 'notification-list__email'
    }, 'E-mail for registration: ', email), _react2.default.createElement('span', {
      className: 'notification-list__country'
    }, 'Country: ', country));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.USER_PROFILE_UPDATE, [{
  users: [_userTypes2.default.SUPER_ADMIN],
  pushTitle: function pushTitle() {
    return 'User profile is updated';
  },
  group: notificationGroup.USER,
  title: function title(_ref111) {
    var userName = _ref111.userName;
    return "".concat(userName, " registration information is changed");
  },
  content: function content(_ref112) {
    var userName = _ref112.userName,
        type = _ref112.type,
        userId = _ref112.userId,
        userType = _ref112.userType;
    return _react2.default.createElement(_react2.default.Fragment, null, "".concat(userName, " ").concat((0, _stringFormatters.stringTypeNormalizer)(userType, '_'), " changed registration information. View profile details "), _react2.default.createElement(_reactRouterDom.Link, {
      to: {
        pathname: "".concat(_urlLocations.KYCUserStatus, "/").concat(userId, "?projectionName=").concat(projectionTypes[type]),
        state: {
          projection: type
        }
      }
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.MANGOPAY_ACCOUNT_NOT_CREATED, [{
  users: [_userTypes2.default.SUPER_ADMIN],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return "".concat(paymentProvider, " user wasn't created");
  },
  title: function title() {
    return "".concat(paymentProvider, " user wasn't created");
  },
  content: function content(_ref113) {
    var email = _ref113.email,
        subDomain = _ref113.subDomain,
        userType = _ref113.userType;
    var isUser = new _IsUser2.default(userType);
    return _react2.default.createElement(_react2.default.Fragment, null, "Mangopay account wasn't created for ".concat((0, _stringFormatters.stringTypeNormalizer)(userType), " with e-mail: ").concat(email, ". "), isUser.investorSP || isUser.issuerSP ? "SP sub-domain: ".concat(subDomain, ". ") : null, 'Please check it on Mangopay Admin panel.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_CREATOR_CONTACT_REQUEST, [{
  users: [_userTypes2.default.ISSUER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref114) {
    var investorFullName = _ref114.investorFullName;
    return "Direct message from investor ".concat(investorFullName);
  },
  title: function title(_ref115) {
    var investorFullName = _ref115.investorFullName;
    return "Direct message from investor ".concat(investorFullName);
  },
  content: function content(_ref116) {
    var investorFullName = _ref116.investorFullName,
        projectTitle = _ref116.projectTitle,
        message = _ref116.message,
        amount = _ref116.amount,
        currency = _ref116.currency,
        investorMobile = _ref116.investorMobile,
        investorEmail = _ref116.investorEmail,
        projectId = _ref116.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, 'You received message from investor ', investorFullName, ' regarding your project', ' ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), '.', _react2.default.createElement('br', null), 'Message: "', message, '"', _react2.default.createElement('br', null), 'Indicative interest is: ', (0, _utils.numberFormat)(amount, 0, '.', ','), ' ', currency, _react2.default.createElement('br', null), 'Mobile phone to contact Investor: ', investorMobile, _react2.default.createElement('br', null), 'E-mail to contact Investor: ', investorEmail);
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_POC_CONTACT_REQUEST, [{
  users: [_userTypes2.default.WORKER_STRATEGIC_PARTNER, _userTypes2.default.ISSUER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref117) {
    var investorFullName = _ref117.investorFullName;
    return "Direct message from investor ".concat(investorFullName);
  },
  title: function title(_ref118) {
    var investorFullName = _ref118.investorFullName;
    return "Direct message from investor ".concat(investorFullName);
  },
  content: function content(_ref119) {
    var investorFullName = _ref119.investorFullName,
        projectTitle = _ref119.projectTitle,
        message = _ref119.message,
        amount = _ref119.amount,
        currency = _ref119.currency,
        investorMobile = _ref119.investorMobile,
        investorEmail = _ref119.investorEmail,
        projectId = _ref119.projectId,
        issuerMobile = _ref119.issuerMobile,
        issuerEmail = _ref119.issuerEmail,
        issuerName = _ref119.issuerName;
    return _react2.default.createElement(_react2.default.Fragment, null, 'You received message from investor ', investorFullName, ' regarding project', ' ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), '.', _react2.default.createElement('br', null), 'Message: "', message, '"', _react2.default.createElement('br', null), 'Indicative interest is: ', (0, _utils.numberFormat)(amount, 0, '.', ','), ' ', currency, _react2.default.createElement('br', null), 'Mobile phone to contact Investor: ', investorMobile, _react2.default.createElement('br', null), 'E-mail to contact Investor: ', investorEmail);
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_POC_CONTACT_REQUEST_WITH_INTERNAL_POC_DETAILS, [{
  users: [_userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref120) {
    var investorFullName = _ref120.investorFullName;
    return "Direct message from investor ".concat(investorFullName);
  },
  title: function title(_ref121) {
    var investorFullName = _ref121.investorFullName;
    return "Direct message from investor ".concat(investorFullName);
  },
  content: function content(_ref122) {
    var investorFullName = _ref122.investorFullName,
        projectTitle = _ref122.projectTitle,
        message = _ref122.message,
        amount = _ref122.amount,
        currency = _ref122.currency,
        investorMobile = _ref122.investorMobile,
        investorEmail = _ref122.investorEmail,
        projectId = _ref122.projectId,
        issuerMobile = _ref122.issuerMobile,
        internalPocNames = _ref122.internalPocNames,
        internalPocEmails = _ref122.internalPocEmails;
    return _react2.default.createElement(_react2.default.Fragment, null, 'You received message from investor ', investorFullName, ' regarding project', ' ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), '.', _react2.default.createElement('br', null), 'Message: "', message, '"', _react2.default.createElement('br', null), 'Indicative interest is: ', (0, _utils.numberFormat)(amount, 0, '.', ','), ' ', currency, _react2.default.createElement('br', null), 'Mobile phone to contact Investor: ', investorMobile, _react2.default.createElement('br', null), 'E-mail to contact Investor: ', investorEmail);
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_CLIENT_CONTACT_REQUEST, [{
  users: [_userTypes2.default.INVESTOR, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER, _userTypes2.default.WORKER_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref123) {
    var issuerFullName = _ref123.issuerFullName;
    return "Your message was sent to issuer ".concat(issuerFullName);
  },
  title: function title(_ref124) {
    var issuerFullName = _ref124.issuerFullName;
    return "Your message was sent to issuer ".concat(issuerFullName);
  },
  content: function content(_ref125) {
    var rmFullName = _ref125.rmFullName,
        issuerFullName = _ref125.issuerFullName,
        projectTitle = _ref125.projectTitle,
        message = _ref125.message,
        amount = _ref125.amount,
        currency = _ref125.currency,
        investorMobile = _ref125.investorMobile,
        investorEmail = _ref125.investorEmail,
        projectId = _ref125.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, 'Your message was sent to ', issuerFullName, ' regarding project', ' ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), '.', _react2.default.createElement('br', null), 'Message: "', message, '"', _react2.default.createElement('br', null), 'Indicative interest is: ', (0, _utils.numberFormat)(amount, 0, '.', ','), ' ', currency, _react2.default.createElement('br', null), 'Mobile phone to contact you: ', investorMobile, _react2.default.createElement('br', null), 'E-mail to contact you: ', investorEmail);
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.PROJECT_SP_CLIENT_CONTACT_REQUEST, [{
  users: [_userTypes2.default.INVESTOR, _userTypes2.default.INVESTOR_STRATEGIC_PARTNER],
  group: notificationGroup.PROJECT,
  pushTitle: function pushTitle(_ref126) {
    var issuerFullName = _ref126.issuerFullName;
    return "Your message was sent to issuer ".concat(issuerFullName);
  },
  title: function title(_ref127) {
    var issuerFullName = _ref127.issuerFullName;
    return "Your message was sent to issuer ".concat(issuerFullName);
  },
  content: function content(_ref128) {
    var issuerFullName = _ref128.issuerFullName,
        projectTitle = _ref128.projectTitle,
        message = _ref128.message,
        amount = _ref128.amount,
        currency = _ref128.currency,
        investorMobile = _ref128.investorMobile,
        investorEmail = _ref128.investorEmail,
        projectId = _ref128.projectId;
    return _react2.default.createElement(_react2.default.Fragment, null, 'Your message was sent to issuer ', issuerFullName, ' regarding project', ' ', _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(projectDetailsUrl).concat(projectId)
    }, projectTitle), '.', _react2.default.createElement('br', null), 'Message: "', message, '"', _react2.default.createElement('br', null), 'Indicative interest is: ', (0, _utils.numberFormat)(amount, 0, '.', ','), ' ', currency, _react2.default.createElement('br', null), 'Mobile phone to contact you: ', investorMobile, _react2.default.createElement('br', null), 'E-mail to contact Investor: ', investorEmail);
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SUBSCRIPTION_EXPIRATION_AUTO_RENEW_OFF, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref129) {
    var expireInDays = _ref129.expireInDays;
    return "Subscription Expiry Notification";
  },
  title: function title(_ref130) {
    var expireInDays = _ref130.expireInDays;
    return "Subscription Expiry Notification";
  },
  content: function content(_ref131) {
    var expireAt = _ref131.expireAt;
    return _react2.default.createElement(_react2.default.Fragment, null, "Your subscription will expire on ".concat((0, _utils.formatDate)(expireAt, 'DD MMM YYYY HH:mm'), ". \n              To ensure uninterrupted access to the platform, please renew your subscription by contacting our support team.\n            "), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.SUBSCRIPTION_EXPIRATION_AUTO_RENEW_ON, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle(_ref132) {
    var expireInDays = _ref132.expireInDays;
    return "Subscription Expiry Notification";
  },
  title: function title(_ref133) {
    var expireInDays = _ref133.expireInDays;
    return "Subscription Expiry Notification";
  },
  content: function content(_ref134) {
    var expireAt = _ref134.expireAt;
    return _react2.default.createElement(_react2.default.Fragment, null, "Your subscription will expire on ".concat((0, _utils.formatDate)(expireAt, 'DD MMM YYYY HH:mm'), ".  Please reach out to our customer support team to ensure uninterrupted access."));
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.ACTIVE_SUBSCRIPTION_PRICE_CHANGED, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return 'Subscription price was changed';
  },
  title: function title() {
    return 'Subscription price was changed';
  },
  content: function content(_ref135) {
    var expireAt = _ref135.expireAt,
        currentSubscriptionPrice = _ref135.currentSubscriptionPrice,
        newSubscriptionPrice = _ref135.newSubscriptionPrice;
    return _react2.default.createElement(_react2.default.Fragment, null, "Your current subscription price is ".concat(currentSubscriptionPrice, " USD.\n             Starting on ").concat((0, _utils.formatDate)(expireAt, 'DD MMM YYYY'), ", it's price will be ").concat(newSubscriptionPrice, " USD.\n              You can change your subscription type \n            "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(_urlLocations.spSettings, "#subscription")
    }, 'here'), '.');
  }
}]), _defineProperty(_notifications, _notificationTypes2.default.IN_QUEUE_SUBSCRIPTION_PRICE_CHANGED, [{
  users: [_userTypes2.default.ADMIN_STRATEGIC_PARTNER],
  group: notificationGroup.USER,
  pushTitle: function pushTitle() {
    return 'Subscription price was changed';
  },
  title: function title() {
    return 'Subscription price was changed';
  },
  content: function content(_ref136) {
    var expireAt = _ref136.expireAt,
        currentSubscriptionPrice = _ref136.currentSubscriptionPrice,
        newSubscriptionPrice = _ref136.newSubscriptionPrice;
    return _react2.default.createElement(_react2.default.Fragment, null, "Your next (future) subscription price was ".concat(currentSubscriptionPrice, " USD.\n               Starting on ").concat((0, _utils.formatDate)(expireAt, 'DD MMM YYYY'), ", it's price will be ").concat(newSubscriptionPrice, " USD.\n                You can change your subscription type \n            "), _react2.default.createElement(_reactRouterDom.Link, {
      className: 'notification-list__link',
      to: "".concat(_urlLocations.spSettings, "#subscription")
    }, 'here'), '.');
  }
}]), _notifications);

function getNotification(type, userType) {
  // If we don't have this type notification
  if (typeof notifications[type] === 'undefined') {
    return defaultNotification(type);
  } // Check permissions of userType for this notification type


  var allowNotification = notifications[type].filter(function (item) {
    return item.users.includes(userType);
  });
  return allowNotification.length > 0 ? allowNotification[0] : defaultNotification(type);
}